import React, { useState } from 'react';
import { useQuery } from 'react-query';
import api from '../services/api';
import { MagnifyingGlassIcon, FunnelIcon } from '@heroicons/react/24/outline';

const fetchAuditLogs = (params) => api.get('/audit', { params }).then(res => res.data.data);

export default function AuditLog() {
  const [filters, setFilters] = useState({ page: 1, limit: 50 });

  const { data, isLoading } = useQuery(['audit-logs', filters], () => fetchAuditLogs(filters));

  const logs = data?.logs || [];
  const pagination = data?.pagination || {};

  const getSeverityColor = (severity) => {
    const colors = {
      low: 'bg-gray-100 text-gray-800',
      medium: 'bg-yellow-100 text-yellow-800',
      high: 'bg-orange-100 text-orange-800',
      critical: 'bg-red-100 text-red-800'
    };
    return colors[severity] || 'bg-gray-100 text-gray-800';
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Audit Log</h1>
        <p className="mt-1 text-sm text-slate-500">System audit trail and activity logs</p>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1 relative">
              <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
              <input
                type="text"
                placeholder="Search by action, entity type..."
                className="input-field pl-10"
                onChange={(e) => setFilters({ ...filters, action: e.target.value, page: 1 })}
              />
            </div>
            <select
              className="input-field"
              onChange={(e) => setFilters({ ...filters, severity: e.target.value, page: 1 })}
            >
              <option value="">All Severities</option>
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
              <option value="critical">Critical</option>
            </select>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="table-container">
          <table className="data-table">
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>Action</th>
                <th>Entity</th>
                <th>Actor</th>
                <th>Severity</th>
                <th>IP Address</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 bg-white">
              {isLoading ? (
                <tr><td colSpan="6" className="text-center py-8">Loading...</td></tr>
              ) : logs.length === 0 ? (
                <tr><td colSpan="6" className="text-center py-8 text-slate-500">No audit logs found</td></tr>
              ) : (
                logs.map((log) => (
                  <tr key={log.id} className="hover:bg-slate-50">
                    <td className="text-xs">{new Date(log.createdAt).toLocaleString()}</td>
                    <td className="font-medium">{log.action}</td>
                    <td>{log.entityType} {log.entityId && `(${log.entityId})`}</td>
                    <td>{log.actorType}: {log.actorId?.substring(0, 8)}...</td>
                    <td>
                      <span className={`badge ${getSeverityColor(log.severity)}`}>
                        {log.severity}
                      </span>
                    </td>
                    <td className="font-mono text-xs">{log.ipAddress}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
